import BaseModelAPI from '../BaseModelAPI';

export default class ProcessTypeList extends BaseModelAPI {

	static entity = 'processtypelist'
	static entityName = 'processtype';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
